angular.module('mtic.components.notifications')
.directive('systemMessage', function ($log, EventManager, $timeout, language, userAccount, api, notificationService, $sce) {
  return {
    templateUrl: 'template.html',
    scope: {
        resourceData: "=",
        iframeStyle: "="
    },
    link: function (scope) {
      var eventManager = new EventManager('systemMessage');
      $log.log('RESOURCE DATA : ', scope.resourceData)
      scope.trustSrc = function(src) {
        return $sce.trustAsResourceUrl(src);
      }
      scope.dismiss = function(){
        eventManager.broadcast('module:close:resource')
        notificationService.dismissNotification(null, false, true);
      }
    }
  }
})
